import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { MainLayoutComponent } from './main-layout';
import { Sidenav } from '../sidenav/sidenav';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    MainLayoutComponent,
    Sidenav
  ],
  exports: [
    MainLayoutComponent,
    Sidenav
  ]
})
export class MainLayoutModule { }

